import * as React from 'react';
import Img from 'gatsby-image';

const ImageEmbedded = (props) => {
  return (
    <img className="block my-4 w-full shadow border-8 border-white rounded" src={props.image["en-US"].fields.file["en-US"].url} alt={props.imageTitle["en-US"]} />
  )
};

export default ImageEmbedded;